{
  "common": {
    "cancel": "Cancel",
    "live": "Live"
  },
  "glossary": {
    "busArrivals": "Bus in arrivo",
    "passingRoutes": "Passing PERCORSI",
    "popOut": "Pop out",
    "seatsAvailable": "Seats available",
    "standingAvailable": "Standing available",
    "limitedStanding": "Limited standing",
    "arriving": "Arr",
    "arrivingMinutes": "{{count}}m",
    "arrivingMinutes_plural": "{{count}}m",
    "multiRouteMode": "Multi-route mode",
    "nRoutes": "{{count}} PERCORSI",
    "nRoutes_plural": "{{count}} PERCORSI",
    "nStops": "{{count}} FERMATE",
    "nStops_plural": "{{count}} FERMATE",
    "nServices": "{{count}} Servizio",
    "nServices_plural": "{{count}} services",
    "weekdaysShort": "WD",
    "weekdays": "Weekdays",
    "saturdaysShort": "SAT",
    "saturdays": "Saturdays",
    "sundaysPublicHolidaysShort": "SUN",
    "sundaysPublicHolidays": "Sunday & Public Holidays",
    "service": "Servizio",
    "firstBus": "Primo Bus",
    "lastBus": "Last Bus"
  },
  "app": {
    "name": "PrioloBus PB",
    "title": "$t(app.name) - Trasporto Pubblico Locale a Priolo Gargallo",
    "shortDescription": "Priolo Bus Routes Explorer",
    "description": "Esplora le fermate e i percorsi sulla mappa dei servizi bus di Priolo Gargallo, con gli orari di arrivo in tempo reale per ogni bus e per ogni fermata."
  },
  "about": {
    "disclaimerCopyright": "Il servizio è offerto dal Comune di Priolo Gargallo.",
    "helpTranslations": "",
    "sisterSites": "In collaborazione con 🚌 Autoservizi Rosario Pappalardo Srl ©",
    "liking": "Visita il Sito",
    "treatCoffee": "www.priolobus.com",
    "treatCoffee1": "https://www.priolobus.com/",
    "explore": "Esplora fermate e percorsi"
  },
  "search": {
    "placeholder": "Cerca linea o fermata dell’autobus "
  },
  "service": {
    "title": "Bus service {{serviceNumber}}: {{serviceName}} - $t(app.name)",
    "titleMultiple": "Bus services: {{serviceNumbersNames}} - $t(app.name)",
    "oppositeLegend": "Operativa "
  },
  "stop": {
    "title": "Bus stop {{stopNumber}}: {{stopName}} - $t(app.name)",
    "titleRoutes": "Routes passing bus stop {{stopNumber}}: {{stopName}} - $t(app.name)",
    "firstLastBus": "Primo/Ultimo Bus",
    "multipleDirectionsWarning": "Some services serve multiple directions. Open \"Bus arrivals\" to see more details.",
    "liveBusTrack": "{{count}} bus now on track",
    "liveBusTrack_plural": "{{count}} buses now on track."
  },
  "passingRoutes": {
    "passingRoutes": "{{count}} passing route",
    "passingRoutes_plural": "{{count}} passing routes"
  },
  "multiRoute": {
    "addRoute": "Add another bus route",
    "showingServices": "Showing {{count}} service",
    "showingServices_plural": "Showing {{count}} services",
    "intersectingStops": "{{count}} intersecting stop",
    "intersectingStops_plural": "{{count}} intersecting stops"
  },
  "arrivals": {
    "invalidBusStopCode": "Invalid bus stop code.",
    "preHeading": "Bus arrival times",
    "title": "Bus arrival times",
    "titleStop": "Orari di Arrivo Bus per {{stopNumber}} - {{stopName}}",
    "multipleVisitsLegend": "1st or 2nd visit. Bus stops here twice, going in different directions. Check destination before boarding.",
    "wheelchairDisclaimer": " Da questa pagina puoi consultare l'orario di arrivo del bus che stai aspettando. Infatti, è possibile vedere quanti minuti passeranno all'arrivo del prossimo bus."
  },
  "firstLast": {
    "title": "Orari di arrivo del primo e dell'ultimo autobus {{stopNumber}}: {{stopName}}",
    "busStopCodeNotFound": "Bus stop code not found.",
    "preHeading": "Orari di arrivo del primo e dell'ultimo autobus"
  }
}
